import "./App.css";
import MainRoutes from "./Routes/Main_Routes";
import { Provider } from "react-redux";
import { store } from "./redux/Store";

function App() {
  return (
    <>
      <Provider store={store}>
        <MainRoutes />
      </Provider>
    </>
  );
}

export default App;
